import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sub_scroll_wrap" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "scroll_nav" }

import { computed } from "vue";
import { useStore } from "vuex";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useAuth } from "@/composables/useAuth";

export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const { isLoggedIn } = useAuth();

const store = useStore();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", {
            class: _normalizeClass({ on: _ctx.$route.path.includes('sub6') })
          }, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).About.Path}`,
              alt: "연구소소개"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" 연구소소개 ")
              ])),
              _: 1
            }, 8, ["to"])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({ on: _ctx.$route.path.includes(_unref(USER_ROUTES).PRIVACY) })
          }, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Privacy.Path}`,
              alt: "개인정보처리방침"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode(" 개인정보처리방침 ")
              ])),
              _: 1
            }, 8, ["to"])
          ], 2),
          _createElementVNode("li", {
            class: _normalizeClass({
              on:
                _ctx.$route.path.includes(_unref(USER_ROUTES).QNA) ||
                _ctx.$route.path.includes(_unref(USER_ROUTES).NOTICE) ||
                _ctx.$route.path.includes(_unref(USER_ROUTES).PRESS) ||
                _ctx.$route.path.includes(_unref(USER_ROUTES).INQUIRY),
            })
          }, [
            _createVNode(_component_router_link, {
              to: `${_unref(USER_ROUTES).Qna.Path}`,
              alt: "커뮤니티"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" 커뮤니티 ")
              ])),
              _: 1
            }, 8, ["to"])
          ], 2)
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "prev" }, null, -1)),
      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "next" }, null, -1))
    ])
  ]))
}
}

})